/**
 * Shared QueryClient Instance
 *
 * Single QueryClient used across all Room apps to prevent duplicate caches
 * and ensure consistent query behavior. Individual pages or apps can override
 * with their own instance via the `queryClient` prop on RootLayout/PageLayout.
 */

import { QueryClient } from '@tanstack/react-query';

export const sharedQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30000, // 30 seconds
    },
  },
});
